import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {ErrorService} from './error.service';

@Injectable()
export class UncaughtHandler implements ErrorHandler {
  constructor(private injector: Injector) {
  }

  public handleError(error: Error) {
    const errorHandler = this.injector.get(ErrorService);
    errorHandler.errorHandlerUncaught(error);
  }
}
